// @flow

import * as React from "react"
import ClassNames from "classnames"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import Icon from "../../icon"
import Config from "../../../config"
import ShopAdminEditItemModal from "../../modals/shop-admin-edit-item"
import ShopAdminMediaModal from "../../modals/shop-admin-media"
import ConfirmModal from "../../modals/confirm"
import {
  toggleSelectedShopItem,
  deleteShopItem,
  clearShopItemMedia,
} from "../../../actions/shop"
import {isShopItemSelected} from "../../../reducers/shop"
import {toDinero} from "../../../util"
import type {ShopItem, Dispatch, State as ReduxState} from "../../../types"

type Props = {
  +t: any,
  item: ShopItem,
  dispatch: Dispatch,
  selectedShopItems: $ReadOnlyArray<number>,
}

type State = {
  +isEditModalOpen: boolean,
  +isDeleteModalOpen: boolean,
  +isMediaModalOpen: boolean,
}

class ShopAdminItemListItem extends React.Component<Props, State> {
  handleShowEditModal: () => void
  handleCloseEditModal: () => void
  handleConfirmDeleteModal: () => void
  handleCloseDeleteModal: () => void
  handleShowDeleteModal: () => void
  handleToggleSelected: () => void
  handleShowMediaModal: () => void
  handleCloseMediaModal: () => void
  handleClick: () => void

  constructor(props: Props) {
    super(props)

    this.state = {
      isDeleteModalOpen: false,
      isEditModalOpen: false,
      isMediaModalOpen: false,
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleConfirmDeleteModal = this.handleConfirmDeleteModal.bind(this)
    this.handleCloseEditModal = this.handleCloseEditModal.bind(this)
    this.handleShowEditModal = this.handleShowEditModal.bind(this)
    this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this)
    this.handleShowDeleteModal = this.handleShowDeleteModal.bind(this)
    this.handleToggleSelected = this.handleToggleSelected.bind(this)
    this.handleShowMediaModal = this.handleShowMediaModal.bind(this)
    this.handleCloseMediaModal = this.handleCloseMediaModal.bind(this)
  }

  handleShowEditModal() {
    this.setState({isEditModalOpen: true})
  }

  handleCloseEditModal() {
    this.setState({isEditModalOpen: false})
  }

  handleShowDeleteModal() {
    this.setState({isDeleteModalOpen: true})
  }

  handleCloseDeleteModal() {
    this.setState({isDeleteModalOpen: false})
  }

  handleConfirmDeleteModal() {
    const {
      dispatch,
      item: {id},
    } = this.props
    dispatch(deleteShopItem(Config.data.babyToken, id))
    this.setState({isDeleteModalOpen: false})
  }

  handleShowMediaModal() {
    this.setState({isMediaModalOpen: true})
  }

  handleCloseMediaModal() {
    this.props.dispatch(clearShopItemMedia())
    this.setState({isMediaModalOpen: false})
  }

  handleClick() {
    //
  }

  handleToggleSelected() {
    const {
      item: {id},
      dispatch,
    } = this.props
    dispatch(toggleSelectedShopItem(id))
  }

  renderModal() {
    const {isDeleteModalOpen, isEditModalOpen, isMediaModalOpen} = this.state
    if (isDeleteModalOpen) {
      return (
        <ConfirmModal
          onConfirm={this.handleConfirmDeleteModal}
          onCancel={this.handleCloseDeleteModal}
        />
      )
    }
    if (isEditModalOpen) {
      return (
        <ShopAdminEditItemModal
          item={this.props.item}
          onClose={this.handleCloseEditModal}
        />
      )
    }
    if (isMediaModalOpen) {
      return (
        <ShopAdminMediaModal
          item={this.props.item}
          onClose={this.handleCloseMediaModal}
        />
      )
    }
  }

  renderCheckbox() {
    const {
      item: {id},
      selectedShopItems,
    } = this.props
    const iconName = isShopItemSelected(id, selectedShopItems)
      ? "icon-checkbox-checked"
      : "icon-checkbox-unchecked"
    return (
      <button
        className="btn btn-icon item-check"
        onClick={this.handleToggleSelected}
      >
        <Icon name={iconName} />
      </button>
    )
  }

  render() {
    const {item, t} = this.props
    const {isCash} = item
    const baseClass = ClassNames("shop-admin-item-list-item", "flex", {
      "is-sold-out": item.isSoldOut,
    })
    const priceClass = ClassNames("badge badge-secondary mr-2", {
      "badge-warning": item.priceSelling == "0",
    })
    const media = item.media.length
      ? item.media[0].sizes.small
      : "/images/logo.jpg"
    return (
      <li className={baseClass} onClick={this.handleClick}>
        <button
          type="button"
          className="btn shop-admin-item-list-item-image-edit"
          onClick={this.handleShowMediaModal}
        >
          <img
            className="shop-admin-item-list-item-image"
            src={media}
            width="60"
            alt=""
          />
        </button>

        <div className="shop-admin-item-list-item-main flex-grow-1">
          <h2 className="h3 shop-admin-item-list-item-name">
            {maybeText(item, "name")}{" "}
          </h2>
          <div>
            {!isCash && (
              <span className="badge badge-secondary mr-2">
                {t("shopAdmin.parts")}: {item.parts}
              </span>
            )}
            {!isCash && (
              <span className="badge badge-secondary mr-2">
                {t("shopAdmin.amount")}: {item.amount}
              </span>
            )}
            {item.sells && item.sells > 0 ? (
              <span
                className="badge badge-info mr-2"
                style={{backgroundColor: "#0C80F5"}}
              >
                {t("shopAdmin.sold")}: {item.sells}
              </span>
            ) : null}
            {!isCash && (
              <span className={priceClass}>
                {t("shopAdmin.price")}:{" "}
                {toDinero(item.priceSelling)
                  .add(toDinero(item.orderCost))
                  .toFormat("$0,0.00")}{" "}
                {item.parts > 1 && t("shopAdmin.perPart")}
              </span>
            )}
          </div>
          <div className="text-gray pt-2 pb-2 pr-4 pl-0">
            {maybeText(item, "description")}
          </div>
          <span className="badge badge-info">{item.type}</span>
          {item.isPublished && (
            <span className="badge badge-success ml-2">published</span>
          )}
          {item.isSticky && (
            <span className="badge badge-warning ml-2">sticky</span>
          )}
          {item.isSoldOut && (
            <span className="badge badge-danger ml-2">sold out</span>
          )}
        </div>
        <div className="shop-admin-item-list-item-actions flex flex-column align-items-end justify-content-between">
          <div className="d-flex flex-column mb-2">
            <button
              className="btn btn-icon item-edit"
              onClick={this.handleShowEditModal}
            >
              <Icon name="icon-edit" />
            </button>
            {!item.isSoldOut &&
              !isCash &&
              !item.isPublished &&
              (!item.sells || item.sells == 0) && (
                <button
                  className="btn btn-icon item-delete"
                  onClick={this.handleShowDeleteModal}
                >
                  <Icon name="icon-trash" />
                </button>
              )}
          </div>
          <div>{this.renderCheckbox()}</div>
        </div>
        {this.renderModal()}
      </li>
    )
  }
}

const maybeText = (item, prop) => {
  let val = item[`${prop}Nl`]

  if (val == "" || val == null || val == undefined) {
    val = item[`${prop}Fr`]
    if (val == "" || val == null || val == undefined) {
      val = item[`${prop}En`]
    }
  }

  return val
}

const mapStateToProps = (state: ReduxState) => ({
  selectedShopItems: state.shop.selectedShopItems,
})

export default withTranslation()(
  connect(mapStateToProps)(ShopAdminItemListItem)
)
